<template>
  <div class="row mt-6">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>
            <i class="fe fe-credit-card"></i>
            <strong>{{ cofs.length }} Change of Providers </strong>
          </h5>
        </div>
        <div class="table-responsive">
          <table class="table align-td-middle card-body">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Previous HCP</th>
                <th>New HCP</th>
                <th>Reason</th>
                <th>Staff</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cof, index) in cofs" v-bind:key="cof.id">
                <td>{{ index + 1 }}</td>
                <td>{{ cof.oldfacility.agency_name }}</td>
                <td>{{ cof.newfacility.agency_name }}</td>
                <td>{{ cof.reason_for_change }}</td>
                <td>
                  <span v-if="cof.staff != null">
                    {{ cof.staff.full_name }}
                  </span>
                </td>
                <td>
                  {{ cof.created_at | moment("dddd, MMMM Do YYYY") }}
                </td>

                <td>

                  <button type="button" class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark">
                    {{ cof.status }}
                  </button>

                  <a v-if="cof.document != null" class="btn btn-link" target="_blank"
                    :href="`https://claimify-api.hayokmedicare.ng/documents/${cof.document.document}`">
                    view proof
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["cofs"],
    data() {
      return {};
    },

    methods: {
      gotoTrxImage(trx) {
        this.axios
          .get(`/api/v1/auth/get/transaction-document/${trx.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Gotten Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.trx_doc = response.data.data;
            this.trx_image = true;
            this.trxtableclass = "col-md-8";
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  };
</script>